module["exports"] = [
  "visa",
  "mastercard",
  "americanexpress",
  "discover"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/business/credit_card_types.js
// module id = 579
// module chunks = 0